import React from 'react';
import { Section } from './ui/Section';
import { AlertTriangle } from 'lucide-react';
export function WhyFailed() {
  return <Section className="bg-[#0a0a0a]" data-id="element-396">
      <div className="max-w-3xl mx-auto" data-id="element-397">
        <div className="flex items-center gap-3 mb-8" data-id="element-398">
          <div className="w-10 h-10 rounded-xl bg-[#06b6d4]/10 border border-[#06b6d4]/20 flex items-center justify-center" data-id="element-399">
            <AlertTriangle className="text-[#06b6d4]" size={20} data-id="element-400" />
          </div>
          <h2 className="text-3xl font-bold text-white" data-id="element-401">
            Por qué lo que intentaste antes falló
          </h2>
        </div>

        <div className="space-y-6 text-lg text-gray-300" data-id="element-402">
          <p data-id="element-403">
            Porque estabas publicando contenido suelto. Tal vez informaba. Tal
            vez entretenía.
          </p>

          <div className="glass-card p-6 md:p-8 space-y-4" data-id="element-404">
            <p className="font-medium text-white" data-id="element-405">Pero no tenía:</p>
            <ul className="space-y-3 text-gray-400" data-id="element-406">
              {['Una ruta de monetización clara', 'Guiones diseñados para la acción', 'CTAs que la gente sí hace', 'Un "lugar" donde la conversión suceda'].map((item, i) => <li key={i} className="flex items-center gap-3" data-id="element-407">
                  <span className="w-1.5 h-1.5 rounded-full bg-[#06b6d4]/60 shrink-0" data-id="element-408" />
                  {item}
                </li>)}
            </ul>
          </div>

          <p className="text-xl font-medium text-white pt-4" data-id="element-409">
            Entonces pasa lo típico:{' '}
            <span className="text-transparent bg-clip-text bg-gradient-to-r from-[#06b6d4] to-[#14b8a6]" data-id="element-410">
              mucho movimiento, cero ingresos.
            </span>
          </p>
        </div>
      </div>
    </Section>;
}